import { Col, Row } from "../../ApiS/Grid-system/Grid-system";

interface CardHallProps {
  check?: boolean;
  title: string;
  CapacityHall: string;
  watt?: boolean;
}

const CardHall: React.FC<CardHallProps> = ({
  check,
  title,
  CapacityHall,
  watt,
}) => {
  return (
    <>
      <Row className="border-2 py-2 !mx-2 rounded-2xl">
        <Col sm={3} md={3} lg={3} className="flex justify-center items-center">
          {check && <input type="checkbox" className="w-7 h-7" />}
        </Col>

        <Col sm={8} md={8} lg={8} className="">
          <div className="font-bold text-base mt-1  "> {title}</div>
          <div className="font-semibold text-base mt-1 ">{CapacityHall} </div>
          {watt && (
            <input
              type="text"
              placeholder="السعة المطلوبة"
              className="bg-[#F6F8F9]  mt-2 py-2 rounded-md"
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default CardHall;
